export enum TipoDocumentoPertencer {
  desconhecido = 'DESCONHECIDO',
  edital = 'EDITAL',
  atas = 'ATAS',
  fotos = 'FOTOS',
}
